import ActiveController from '@/controller.active';

class usersController extends ActiveController{
  constructor(
    $users,
    $companies,
    $rootScope,
    $uibModal
  ){
    'ngInject';

    super();
    this.$users = $users;
    this.$companies = $companies;
    this.$uibModal = $uibModal;
  }
  $onSuspend( user ){
    user.suspended = !user.suspended;
    this.$users.update( user );
  }

  editUser( user ){
    this.$uibModal.open({
      component: 'users-update',
      resolve: {
        items: function () {
          return {
            user: user
          }
        }
      }
    });
  }

  get currentCompany() {
    return this.$companies.currentCompany;
  }

  get availableOperators() {
    return this.currentCompany.invoice_account.allowed_operators;
  }

  getOperators(userOperators) {
    return userOperators.filter(value => this.availableOperators.includes(value)).join(', ');
  }

}
export default usersController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users.controller.js
 **/